export const GROWNI_PAYMENT_BASE_URL = 'https://platby.growni.sk/kontrola-objednavky'
/**
 * One credit is worth one euro (since Oct 2026; before that one credit was 100 € and one job ad).
 * WooCommerce (platby.growni.sk) sells WOOCOMMERCE_CREDIT_PRODUCT_ID at 1 € a piece, so the order
 * quantity is the number of credits; the order webhook adds the bonus. Docs: docs/credits.md.
 * The product must have no quantity discount in WordPress (the bonus replaces it).
 */
export const WOOCOMMERCE_CREDIT_PRODUCT_ID: number = 328

/**
 * The old product, 100 € a piece. Not sold any more, but an order placed before the switch can
 * still reach the webhook: each piece adds LEGACY_CREDIT_PACK_SIZE credits.
 */
export const WOOCOMMERCE_LEGACY_CREDIT_PACK_PRODUCT_ID = 142 // TEST: 209
export const LEGACY_CREDIT_PACK_SIZE = 100

/** Smallest order: one TalentBase reveal (TALENT_BASE_USER_SHOW_PRICE). */
export const MIN_CREDITS_ORDER = 25
export const MAX_CREDITS_ORDER = 9999

/**
 * Bigger orders get extra credits instead of a discount: the price stays credits × 1 €. Sorted
 * from the biggest order down. 2 000+ keeps the value of the old 20 % discount (2 000 € used to
 * buy 2 500 € worth of ads), 500+ gives a round 10 %.
 */
export const CREDIT_BONUS_TIERS = [
    { minCredits: 2000, bonusPercent: 25 },
    { minCredits: 500, bonusPercent: 10 }
] as const

/**
 * Written on every org transaction created since credits are worth one euro. The migration
 * (scripts/credits/migrate-credits-to-eur.cjs) multiplies the amount of every transaction
 * without it by 100 and then sets it, so it can run again safely.
 */
export const CREDIT_UNIT = 'eur'
